import React from "react";

const FilePreviewModal = ({ url, onClose }) => {
  if (!url) return null;

  const isImage = url.startsWith("data:image");

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 max-w-3xl w-full max-h-[80vh] overflow-auto">
        {isImage ? (
          <img
            src={url}
            alt="Preview"
            className="max-h-[70vh] w-auto mx-auto object-contain"
          />
        ) : (
          <embed
            src={url}
            type="application/pdf"
            className="w-full h-[70vh]"
          />
        )}
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
